var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowStairs = function SvgArrowStairs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 188,
    viewBox: "0 0 77.7 188"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.1 186.7 6.5-6.6c.3-.3.3-.9 0-1.3l-1.3-1.3c-.3-.3-.9-.3-1.3 0l-4.6 4.6c-.6.6-1.5.2-1.5-.6v-14c0-2.5-2-4.4-4.4-4.4h-7.1c-1.2 0-2.2-1-2.2-2.2v-8c0-2.5-2-4.4-4.4-4.4h-8c-1.2 0-2.2-1-2.2-2.2V.9c0-.5-.4-.9-.9-.9h-1.8c-.5 0-.9.4-.9.9v146.7c0 2.5 2 4.4 4.4 4.4h8c1.2 0 2.2 1 2.2 2.2v8c0 2.5 2 4.4 4.4 4.4h7.1c1.2 0 2.2 1 2.2 2.2v12.7c0 .8-1 1.2-1.5.6l-4.6-4.6c-.3-.3-.9-.3-1.3 0l-1.3 1.3c-.3.3-.3.9 0 1.3l6.5 6.6c.8.8 2 1.3 3.1 1.3h1.4c1.6 0 2.7-.5 3.5-1.3"
  })));
};
export default SvgArrowStairs;